<template>
    <div id="fccDataTipoPublicacao" class="fccSpi">
      <v-select
        :options="listarPublicacaoDataTipo"
        v-model="dataTipoPublicacao"
        :placeholder="name"
        class="selectSPI"
        label="dstipo"
        @input="setSelected"
      >
        <template #search="{attributes, events}">
            <input
             class="vs__search"
            :required="!dataTipoPublicacao"
            v-bind="attributes"
             v-on="events"
            />
        </template>
      </v-select>
    </div>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import './assets/fccSpi.scss'

export default {
  name: 'fccDataTipoPublicacao',
  data: () => ({
    listarPublicacaoDataTipo: [],
    dataTipoPublicacao: '',
    name: 'Selecione o Tipo de Publicação'
  }),
  methods: {
    setSelected: function () {
      this.$emit('changesDataTipoPublicacao', this.dataTipoPublicacao)
    },
    listandoDataTipoPublicacao: function () {
      axios.get(store.state.baseUrlPublicacao + 'PublicacaoDataTipo/ListarPublicacaoDataTipo', this.dadosLoginSession.fccTokenHeaders)
        .then(response => {
          this.listarPublicacaoDataTipo = response.data
        })
        .catch(this.setErrorSystem)
    }
  },
  mounted: function () {
    this.listandoDataTipoPublicacao()
  }
}
</script>
